/************************************************************
 * Project: Books-App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 8, 2020.
 * Description: Assignment - Books-App
 * https://github.com/maasantos10/
 ************************************************************/

import React from 'react';

import { ToastProvider } from './toast';

const AppProvider: React.FC = ({ children }) => (

  <ToastProvider>{children}</ToastProvider>

);

export default AppProvider;
